export default function (instance) {
    return {
        getApiKey(){
            return instance.get('payment/apikey')
        },
        getCards(){
            return instance.get('payment/cards')
        },
        createCard(){
            return instance.postForm('payment/cards')
        },
        checkCard(payload){
            return instance.postForm('payment/cards/check', payload)
        },
        deleteCard(id){
            return instance.delete('payment/cards/' + id)
        },
        checkInvoice(payload){
            return instance.get('payment/check-by-invoice', payload)
        },
        createInvoice(payload){
            return instance.postForm('payment/invoice', payload)
        },
        pay(payload){
            return instance.postForm('payment/pay', payload)
        },
        promocode(payload){
            return instance.get('promocode', payload)
        },
        payUseDeposit(payload){
            return instance.postForm('payment/pay-use-deposit', payload)
        },
    }
}